export const eventsConstants = {
  GETEVENTS_REQUEST: 'GETEVENTS_REQUEST',
  GETEVENTS_SUCCESS: 'GETEVENTS_SUCCESS',
  GETEVENTS_FAILURE: 'GETEVENTS_FAILURE',
  CHANGE_MATERIALS_INFO: 'CHANGE_MATERIALS_INFO',
  GETEVENT_PRESETS_REQUEST: 'GETEVENT_PRESETS_REQUEST',
  GETEVENT_PRESETS_SUCCESS: 'GETEVENT_PRESETS_SUCCESS',
  GETEVENT_PRESETS_FAILURE: 'GETEVENT_PRESETS_FAILURE',
};
